/**
 * @param {Object} props
 * @param {IconSize} [props.iconSize]
 * @returns {React.ReactElement} The rendered component
 */
const Reset = ({ iconSize }) => {
  if (iconSize === 'md') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 11C19.7554 9.24017 18.9391 7.60961 17.6766 6.35945C16.4142 5.10928 14.7758 4.30887 13.0137 4.0815C11.2516 3.85414 9.46362 4.21243 7.9252 5.1012C6.38678 5.98996 5.18325 7.35989 4.5 8.99995M4 4.99995V8.99995H8M4 13C4.24456 14.7598 5.06093 16.3903 6.32336 17.6405C7.58579 18.8907 9.22424 19.6911 10.9863 19.9184C12.7484 20.1458 14.5364 19.7875 16.0748 18.8988C17.6132 18.01 18.8168 16.6401 19.5 15M20 19V15H16"
          stroke="#002967"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3820_3779)">
        <path
          d="M15 7.12499C14.786 5.58518 14.0717 4.15844 12.9671 3.06455C11.8624 1.97065 10.4288 1.27029 8.88696 1.07135C7.34514 0.872401 5.78067 1.18591 4.43455 1.96358C3.08843 2.74125 2.03534 3.93993 1.4375 5.37499M1 1.87499V5.37499H4.5M1 8.87503C1.21399 10.4148 1.92831 11.8416 3.03294 12.9355C4.13757 14.0294 5.57121 14.7297 7.11304 14.9287C8.65486 15.1276 10.2193 14.8141 11.5654 14.0364C12.9116 13.2588 13.9647 12.0601 14.5625 10.625M15 14.125V10.625H11.5"
          stroke="#002967"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3820_3779">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Reset;
